import React, {useState, useCallback} from 'react';
import { connect } from "react-redux";
import {SENDS_ONLY, MASTER} from 'constants/track-output-types.js';
import Dropdown from 'react-dropdown';

const TrackOutputType = ({track, outputType, className}) => {
    const onChange = useCallback(({value}) => {
        track.outputTypeParameter.set(value);
    }, []);

    let options = [
        {value: MASTER, label: "Mix"},
        {value: SENDS_ONLY, label: "Sends Only"}
    ];
    let option = {
        value: outputType,
        label: getLabel(outputType)
    };

    return (
        <div className="track-output-type">
          <div className="track-output-type-label">
          Audio To
          </div>
          <Dropdown
            className={className || 'osc-type-dropdown float-left'}
            controlClassName={className || 'osc-type-control-dropdown'}
            arrowClassName={className || 'osc-type-arrow-dropdown'}
            options={options}
            onChange={onChange}
            value={option}
            placeholder="Audio To" />
        </div>
    );
};

const getLabel = (outputType) => {
    if (outputType === MASTER) {
        return "Mix";
    } else {
        return "Sends Only";
    }
};

const mapStateToProps = (state, props) => {
   return {
       outputType: props.track.outputTypeParameter && props.track.outputTypeParameter.get()
    };
};


export default connect(mapStateToProps, null)(TrackOutputType);
